import React, { useEffect, useRef } from "react";
import "./DosaChutneyAbout.scss"
import heroBackground from "../../assets/images/galleryBg.png"
import border from "../../assets/images/border.png"
import tripAdvisor from "../../assets/images/tripAdvisor.png"

const DosaChutneyAbout = () => {
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const images = [
        { "src": "https://plus.unsplash.com/premium_photo-1665669263531-cdcbe18e7fe4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmFrZXJ5fGVufDB8fDB8fHww" },
        { "src": "https://plus.unsplash.com/premium_photo-1675788938970-e2716f23b1f9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8YmFrZXJ5fGVufDB8fDB8fHww" },
        { "src": "https://images.unsplash.com/photo-1534432182912-63863115e106?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzJ8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1618427012166-b0e03d490a4a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDB8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1519915028121-7d3463d20b13?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NzR8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1609590981063-d495e2914ce4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8ODF8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1580959422798-c487f21d1a08?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTcwfHxiYWtlcnl8ZW58MHx8MHx8fDA%3D" },
        { "src": "https://images.unsplash.com/photo-1629320119721-5a2aa9ce9dbf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjAzfHxiYWtlcnl8ZW58MHx8MHx8fDA%3D" },
        { "src": "https://images.unsplash.com/photo-1619286311276-d8343d00ce1f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjQ2fHxiYWtlcnl8ZW58MHx8MHx8fDA%3D" },
    ]
    useEffect(() => {
        // const container = containerRef.current;
        // const content = contentRef.current;

        // if (!container || !content) return;

        // let scrollLeft = 0;
        // let animationFrame;

        // const clone = content.cloneNode(true);
        // container.appendChild(clone);

        // const animate = () => {
        //     scrollLeft += 0.5;
        //     if (scrollLeft >= content.scrollWidth) {
        //         scrollLeft = 0;// Reset seamlessly
        //     }
        //     container.scrollLeft = scrollLeft;
        //     animationFrame = requestAnimationFrame(animate);
        // };

        // animationFrame = requestAnimationFrame(animate);

        // return () => cancelAnimationFrame(animationFrame);
    }, []);
    const getImagesCarousel = (data) => {
        return (
            <div className="DosaChutneyAbout-ImageCarousel" ref={containerRef}>
                <div className="DosaChutneyAbout-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="DosaChutneyAbout-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }
    return (
        <div className="DosaChutneyAbout">
            <div className="DosaChutneyAbout-Hero"
                style={{
                    backgroundImage: `linear-gradient(135deg, rgba(32, 70, 7, 0.59), rgba(19, 44, 2, 0.7)), url(${heroBackground})`
                }}>
                <div className="DosaChutneyAbout-Hero-header">
                    About Us
                </div>
                <div className="DosaChutneyAbout-Hero-subheader">
                    We'd love to hear from you
                </div>
            </div>
            <div className="DosaChutneyAbout-Container">
                <div className="DosaChutneyAbout-Container-left">
                    <img alt="" src={tripAdvisor} className="DosaChutneyAbout-Container-tripAdvisor" />
                    <div className="DosaChutneyAbout-Container-left-imgs">
                        <div className="DosaChutneyAbout-Container-left-imgs-left">
                            <img alt="" src="https://media.istockphoto.com/id/849749746/photo/middle-eastern-meze-platter-with-green-falafel-pita-sun-dried-tomatoes-pumpkin-and-beet-hummus.jpg?s=612x612&w=0&k=20&c=jxRzenS_xqbmHnBOYRziLAzDP1faJMAjvznMUncKM1s=" />
                            <img alt="" src="https://images.unsplash.com/photo-1694849789325-914b71ab4075?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8ZG9zYXxlbnwwfHwwfHx8MA%3D%3D" />
                        </div>
                        <img alt="" src="https://images.unsplash.com/photo-1710091691777-3115088962c4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHJpY2UlMjBhbmQlMjBjdXJyeXxlbnwwfHwwfHx8MA%3D%3D" className="DosaChutneyAbout-Container-left-imgs-right" />
                    </div>
                </div>
                <div className="DosaChutneyAbout-Container-right">
                    <div className="DosaChutneyAbout-Container-right-header">
                        <div className="DosaChutneyAbout-Container-right-header-subtext">
                            In tooting
                        </div>
                        <div className="DosaChutneyAbout-Container-right-header-text">
                            Dosa n Chutney
                        </div>
                        <img alt="" src={border}
                            className="DosaChutneyAbout-Container-right-header-border" />
                    </div>
                    <div className="DosaChutneyAbout-Container-right-boldConent">
                        Authentic South Indian  Flavours, Celebrated with Passion and Freshness in the Heart of London
                    </div>
                    <div className="DosaChutneyAbout-Container-right-content">
                        Welcome to Dosa n Chutney, where we invite you to embark on a culinary journey through the exquisite flavours of South India. Our restaurant is more than a dining destination; it is a celebration of the region’s rich cultural heritage and vibrant culinary traditions.
                    </div>
                    <div className="DosaChutneyAbout-Container-right-content">Nestled in the heart of London, we take pride in serving authentic South Indian cuisine crafted with passion and expertise. From the crisp dosas to the tangy richness of sambar, each dish showcases the vibrant spices and diverse ingredients that define South Indian cooking. Our skilled chefs blend traditional recipes with modern techniques to deliver an unforgettable dining experience that delights all the senses.
                    </div>
                    <div className="DosaChutneyAbout-Container-right-content">We are dedicated to sourcing the finest, freshest ingredients, ensuring every dish bursts with flavour and authenticity. Join us at Dosa n Chutney and let us guide you on a gastronomic journey through the true tastes of South India.
                    </div>
                </div>
            </div>
            {getImagesCarousel(images)}
        </div>
    )
}
export default DosaChutneyAbout